// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3js23","inputWrap":"styles_inputWrap__2dVFN","input":"styles_input__2y17N"};